"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CheckboxGeneralHandler", {
    enumerable: true,
    get: function() {
        return CheckboxGeneralHandler;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _catchError = require("src/helpers/catchError");
const _generic = require("~/db/field-handler/handlers/generic");
let CheckboxGeneralHandler = class CheckboxGeneralHandler extends _generic.GenericFieldHandler {
    async verifyFilter(filter, column) {
        const supportedOperations = [
            'eq',
            'neq',
            'blank',
            'notblank',
            'checked',
            'notchecked',
            'is',
            'isnot'
        ];
        if (!supportedOperations.includes(filter.comparison_op)) {
            return {
                isValid: false,
                errors: [
                    `Operation ${filter.comparison_op} is not supported for type ${column.uidt} on column ${column.title}`
                ]
            };
        }
        if ([
            'eq',
            'neq'
        ].includes(filter.comparison_op) && ![
            null,
            true,
            false,
            'true',
            'false',
            '',
            1,
            0,
            '1',
            '0'
        ].includes(filter.value)) {
            return {
                isValid: false,
                errors: [
                    `Value ${filter.value} is not supported for type ${column.uidt} on column ${column.title}`
                ]
            };
        }
        return {
            isValid: true
        };
    }
    async parseUserInput(params) {
        if ((0, _nocodbsdk.ncIsUndefined)(params.value)) {
            return {
                value: params.value
            };
        }
        const parsedCheckboxValue = (0, _nocodbsdk.parseCheckboxValue)(params.value);
        if (parsedCheckboxValue === true || parsedCheckboxValue === false) {
            return {
                value: parsedCheckboxValue
            };
        } else {
            _catchError.NcError.invalidValueForField({
                value: params.value,
                column: params.column.title,
                type: params.column.uidt
            });
        }
    }
};
